import { computed, ref } from 'vue'

function _mapMessage(msgs, result, preKey = '') {
    for (const [k, v] of Object.entries(msgs)) {
        if (['string', 'function'].includes(typeof v)) {
            result[`${preKey}${k}`] = v
        } else if (v) {
            _mapMessage(v, result, `${preKey}${k}.`)
        }
    }
    return result
}

function createInstance(globalI18n, locale, messages = {}, isGlobal = false) {
    locale = ref(locale)
    const availableLocales = Object.keys(messages)
    const parsedMsgs = {}
    for (const l of availableLocales) parsedMsgs[l] = _mapMessage(messages[l], {})

    const msgs = computed(() => parsedMsgs[locale.value])
    const _t = (k, p, ops) => {
        const m = parsedMsgs[ops.locale ?? locale.value]?.[k]

        if (typeof m === 'string') return m

        const m2 = m?.(p)

        if (m2 === undefined) {
            return (
                (isGlobal ? undefined : globalI18n._t(k, p, { locale: ops.locale ?? locale.value })) ??
                ops.defaultMsg ??
                k
            )
        }
        return m2
    }

    const t = (k, p, ops) => {
        if (ops === undefined && p && typeof p === 'object') ops = p

        const _ops = ops && typeof ops === 'object' ? ops : {}

        return _t(k, p, _ops)
    }

    return {
        isGlobal,
        locale,
        messages: msgs,
        availableLocales,

        _t,

        t,

        $t: (k, p, ops) => computed(() => t(k, p, ops)),
    }
}

const GLOBAL_I18N = '__global-i18n__'
let i18n

export function createI18n({ locale, messages }) {
    i18n = createInstance(undefined, locale, messages, true)

    return {
        global: i18n,
        install(app) {
            app.provide(GLOBAL_I18N, i18n)
        },
    }
}

export function useI18n(scope = 'global', messages, ops) {
    return scope === 'global' ? i18n : createInstance(i18n, ops?.locale ?? i18n.locale, messages, false)
}

export const lang = {
    zhCN: 'zh-CN',
    enUS: 'en-US',
}

export function loadMsg(msgs, pattern = /\.\/locales\/(.+)\.ts/) {
    pattern = new RegExp(pattern)
    const ret = {}
    for (const [k, msg] of Object.entries(msgs)) {
        ret[pattern.exec(k)[1]] = msg
    }
    return ret
}
